<script setup>
import Drawer from "@js/components/Drawer.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  targets: {
    type: Array,
    required: true,
  },
});

const targetCount = props.targets.reduce(
  (count, variant) => count + variant.googleWebsites.length,
  0,
);

const drawerOpen = ref(false);

const setDrawerOpen = (value) => {
  drawerOpen.value = value;
};
</script>

<template>
  <div class="relative inline-flex h-full items-center justify-start p-4">
    <span
      class="flex cursor-pointer items-center text-blue-500"
      v-on:click="() => setDrawerOpen(true)"
    >
      {{ t("all.label.nTargets", targetCount, { count: targetCount }) }}
    </span>
  </div>

  <Drawer :set-is-open="setDrawerOpen" :is-open="drawerOpen">
    <template #title>
      {{ t("all.label.targets") }}
    </template>
    <template #content>
      <div class="p-4">
        <ul class="mt-2 list-disc pl-8">
          <li
            v-for="variantTargets in props.targets"
            :key="variantTargets.variantId"
          >
            {{ t("all.label.websiteVariant") }} "{{
              variantTargets.variantName
            }}"
            <ul class="list-disc pl-8">
              <li
                v-for="googleWebsite in variantTargets.googleWebsites"
                :key="googleWebsite.id"
              >
                {{ googleWebsite.name }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </template>
  </Drawer>
</template>
